export interface RuntimeAdminEnv {
  ws_url?: string;
  img_baseurl?: string;
  socket_url?: string;
  socket_path?: string;
  base_url?: string;
  public_base_url?: string;
  admin_base_url?: string;
  support_mail?: string;
  enable_chat?: boolean;
}

declare global {
  interface Window {
    __YS_ADMIN_ENV__?: RuntimeAdminEnv;
  }
}

const runtimeEnv: RuntimeAdminEnv =
  typeof window !== 'undefined' && window.__YS_ADMIN_ENV__
    ? window.__YS_ADMIN_ENV__
    : {};

export function runtimeValue(key: keyof RuntimeAdminEnv, fallback: string): string {
  const value = runtimeEnv[key];
  return typeof value === 'string' && value ? value : fallback;
}

export function runtimeBoolean(key: keyof RuntimeAdminEnv, fallback: boolean): boolean {
  return typeof runtimeEnv[key] === 'boolean' ? runtimeEnv[key] as boolean : fallback;
}

export function apiBaseUrl(fallback: string): string {
  return runtimeValue('ws_url', fallback).replace(/\/$/, '');
}

export function assetBaseUrl(fallbackApiUrl: string): string {
  return runtimeValue('img_baseurl', `${apiBaseUrl(fallbackApiUrl)}/`);
}
